import React from 'react';
import { Text } from '@common-fe/common-fe';
export interface Props {
  testId?: string;
}
const PlaceholderBaseDefault: React.FC<Props> = ({ testId = 'placeholder-base' }) => {
  return (
    <Text data-testid={`${testId}_text`} size="large" margin={{ top: 'spacing24' }} weight={700}>
      No data found
    </Text>
  );
};

export default PlaceholderBaseDefault;
